module.exports = __webpack_public_path__ + "img/AZ.bd4b4417.svg";